import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { SystemSpaceSlug, useCreateCollection, useSpaceUtil, useUpdateCollection, } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { Form } from '../Form';
import { T, useI18n } from '../i18n';
export const CollectionFormModal = ({ collection, open, onClose, }) => {
    const intl = useI18n();
    const inputRef = useRef();
    const { mutateAsync: createCollection, isLoading: isCreating } = useCreateCollection({
        fields: 'basic',
    });
    const { mutateAsync: updateCollection, isLoading: isUpdating } = useUpdateCollection();
    const history = useHistory();
    const { generatePath } = useSpaceUtil();
    const isNew = !(collection === null || collection === void 0 ? void 0 : collection.id);
    return (_jsxs(Modal, { open: open, onClose: onClose, initialFocus: inputRef, children: [_jsx(Modal.Header, { title: isNew ? (_jsx(T, { id: "Collection.Create", defaultMessage: "Create a new {COLLECTION}" }, void 0)) : (_jsx(T, { id: "Collection.Edit", defaultMessage: "Edit {COLLECTION}" }, void 0)) }, void 0), _jsx(Modal.Content, { children: _jsx(Form, { defaultValues: collection, onSubmit: async (data) => {
                        const { name, description } = data;
                        const input = {
                            name,
                            description,
                        };
                        if (collection === null || collection === void 0 ? void 0 : collection.id)
                            return updateCollection({
                                id: collection.id,
                                input,
                            }).then(() => {
                                onClose();
                            });
                        return createCollection({
                            input,
                        }).then(collection => {
                            onClose();
                            history.push(generatePath(SystemSpaceSlug.COLLECTION, { id: collection.id }));
                        });
                    }, children: _jsxs("div", { className: "flex flex-col space-y-5", children: [_jsx(Form.Input, { ref: inputRef, label: _jsx(T, { defaultMessage: "Name", id: "CollectionForm.Input.Name.Label" }, void 0), name: "name", placeholder: intl.$t({
                                    defaultMessage: 'Choose a helpful name (e.g. Resources)',
                                    id: 'CollectionForm.Input.Name.Placeholder',
                                }), validation: {
                                    required: intl.$t({
                                        defaultMessage: 'Please enter a name for the {COLLECTION}',
                                        id: 'CollectionForm.Input.Name.Validation.Required',
                                    }),
                                } }, void 0), _jsx(Form.Textarea, { label: _jsx(T, { defaultMessage: "Description", id: "Generics.Description" }, void 0), name: "description", placeholder: intl.$t({
                                    defaultMessage: 'What is this {COLLECTION} about? (e.g. All the resources you need to get started)',
                                    id: 'CollectionForm.Input.Description.Placeholder',
                                }) }, void 0), _jsxs(Form.Actions, { children: [_jsx(Button, { variant: "primary", type: "submit", loading: isCreating || isUpdating, children: isNew ? (_jsx(T, { defaultMessage: "Create", id: "Generics.Create" }, void 0)) : (_jsx(T, { defaultMessage: "Update", id: "Generics.Update" }, void 0)) }, void 0), _jsx(Button, { variant: "outline", onClick: onClose, children: _jsx(T, { defaultMessage: "Cancel", id: "Generics.Cancel" }, void 0) }, void 0)] }, void 0)] }, void 0) }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=CollectionFormModal.js.map